module.exports = __webpack_public_path__ + "img/ricard.ff7585ce.png";